import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  input,
} from '@angular/core';
import { Upsell } from '@core/models';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

/**
 * Presentational "upsell toggle card" (image + title + "+$X Per Ticket" + toggle +
 * selected-state border), per the Figma checkout redesign ("Need more Fun?" grid).
 * Visuals match the "Fan Base Package" card in Figma node 1688:132 (radius, shadow,
 * image size, type scale, info icon, toggle dimensions/colors).
 *
 * Purely a restyle of the existing upsell data already exposed by `group-outing`/
 * `UpgradesService` (DEC-008) — no new data or business logic. GS-local for now
 * (DEC-001); flagged in the redesign plan (section 3) as a candidate for future
 * promotion to the shared SDC library since it has no cart-specific dependency.
 */
@Component({
  selector: 'app-upsell-toggle-card',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, TooltipModule],
  templateUrl: './upsell-toggle-card.component.html',
  styleUrl: './upsell-toggle-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpsellToggleCardComponent {
  upsell = input.required<Upsell>();
  checked = input<boolean>(false);

  @Output() toggle = new EventEmitter<HTMLInputElement>();

  onToggle(radio: HTMLInputElement) {
    this.toggle.emit(radio);
  }
}
